import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import useApi from "../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../common/ToastHandler";
import useSwal from "../../common/ReusableComponent/useSwal";
import ReusableTable from "../../common/ReusableComponent/reusableTable/ReusableTable";

const Documents = () => {
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [hasAnyActions, setHasAnyActions] = useState(true);
  const navigate = useNavigate();
  const { GetPaginatedData, getHost, getAPI, Get, Delete } = useApi();
  const { handleToast } = useToastHandler();
  const { confirmDelete } = useSwal();
  const fetchDocumentData = async ({ page = 1, searchTerm = "" } = {}) => {
    try {
      const response = await GetPaginatedData("document-assignment", {
        page,
        search: searchTerm
      });
      const hasActions = response.data.some(row => !row.store_owner_signed);
      setHasAnyActions(hasActions);
      return {
        data: response.data,
        totalPages: Math.ceil(response.totalCount / 10)
      };
    } catch (error) {
      console.error("Error fetching documents:", error);
      return {
        data: [],
        totalPages: 1
      };
    }
  };


  const resolveDocumentUrl = (documentFile) => {
    if (!documentFile) return null;
    if (/^https?:\/\//i.test(documentFile)) return documentFile;
    const host = getHost().replace(/\/$/, "");
    const path = String(documentFile).replace(/^\/+/, "");
    return `${host}/${path}`;
  };

  const handlePreview = async (documentFile, docId, assignmentData) => {
    let finalDocumentUrl = resolveDocumentUrl(documentFile);
    if (assignmentData.status === "signed") {
      try {
        const apiUrl = `${getAPI("document-assignment")}${docId}/apply_signature/`;
        const response = await Get(apiUrl);
        if (response?.[0]?.signed_document) {
          finalDocumentUrl = resolveDocumentUrl(response[0].signed_document);
        }
      } catch (error) {
        console.error("Error fetching signed document:", error);
      }
    }
    navigate(`/document-preview/${docId}`, {
      state: {
        documentUrl: finalDocumentUrl,
        assignmentData,
        isSignedDocument: assignmentData.status === "signed",
      },
    });
  };

  
  const handleOnDelete = async (id) => {
    const result = await confirmDelete();
    if (!result.isConfirmed) return;
    try {
      await Delete("document-assignment", id);
      handleToast({
        type: "SUCCESS",
        message: "Document deleted successfully"
      });
      setRefreshKey(prev => prev + 1);
    } catch (error) {
      console.error("Error deleting document:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to delete document"
      });
    }
  };
  const getStatusBadge = (status) => {
    const colors = {
      signed: "#28a745",
      sent: "#007bff",
      viewed: "#ffc107",
      draft: "#6c757d",
      completed: "#17a2b8"
    };
    return (
      <span style={{
        padding: "4px 8px",
        fontSize: "12px",
        fontWeight: "600",
        borderRadius: "12px",
        background: colors[status] || "#6c757d",
        color: "#fff",
        textTransform: "uppercase"
      }}>
        {status}
      </span>
    );
  };
const columns = [
  {
    header: "Document Title",
    render: (row) => row.document?.title || "-"
  },
  {
    header: "Description",
    render: (row) => row.document?.description || "-"
  },
  {
    header: "Status",
    render: (row) => getStatusBadge(row.status)
  },
  {
    header: "Viewed At",
    render: (row) =>
      row.viewed_at
        ? new Date(row.viewed_at).toLocaleDateString()
        : "Not viewed"
  },
  {
    header: "Signed At",
    render: (row) =>
      row.signed_at
        ? new Date(row.signed_at).toLocaleDateString()
        : "Not signed"
  },
  ...(hasAnyActions ? [{
    header: "Actions",
    render: (row) => {
      if (row.store_owner_signed) {
        return null;
      }
      return (
        <button
          onClick={() =>
            handlePreview(
              row.document?.document_file,
              row.id,
              row
            )
          }
          style={{
            padding: "6px 12px",
            backgroundColor: "#4f46e5",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "500"
          }}
        >
          👁 View
        </button>
      );
    }
  }] : [])
];
  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="header-row">
          <div className="setting-title">Document Assignments</div>
        </div>
        <ReusableTable
          key={refreshKey}
          fetchData={fetchDocumentData}
          columns={columns}
          showAction={true}
          showFooter={true}
          onDelete={handleOnDelete}
          loading={loading}
          showDelete={true}
        />
      </div>
    </>
  );
};
export default Documents;
